import { useEffect, useState } from "react";
import { useHideComponents } from "@app/hooks/useHideComponents";
import Cookies from "js-cookie";
import { AnimatePresence, motion } from "motion/react";

/** Desktop Onboarding tooltip for pulse variant manual */
const PulseDesktopOnboarding = (): React.ReactElement => {
  const [isVisited, setIsVisited] = useState(true);
  const { isHide, isTimeout } = useHideComponents(10000);

  useEffect(() => {
    const cookie = Cookies.get("bt-pulse-onboarding");
    if (typeof cookie !== "undefined") return;

    setIsVisited(false);
  }, []);

  useEffect(() => {
    if (!isTimeout) return;

    Cookies.set("bt-pulse-onboarding", "shown");
  }, [isTimeout]);

  return (
    <AnimatePresence>
      {!isVisited && !isHide ? (
        <motion.div
          data-testid="pulse-desktop-onboarding-component"
          animate={{
            bottom: "12px",
          }}
          exit={{
            bottom: "-80px",
          }}
          transition={{ duration: 0.7, ease: "linear" }}
          className="absolute -bottom-[80px] left-1/2 flex w-max -translate-x-1/2 items-center justify-center gap-2 overflow-hidden rounded-[0.5rem] border border-white/10 bg-[#1A1A1A] px-10 py-5 font-poppins text-4xs text-white"
        >
          <p className="mb-0">Click on right button or keyboard</p>

          <p className="mb-0 bg-[#313131] p-2 font-bold">←</p>

          <p className="mb-0 bg-[#313131] p-2 font-bold">→</p>

          <p>to navigate.</p>
        </motion.div>
      ) : null}
    </AnimatePresence>
  );
};

export default PulseDesktopOnboarding;
